import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MailIcon } from 'lucide-react';
export const EmailSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-6796">
      <Navbar scrolled={scrolled} data-id="element-6797" />
      <main className="pt-24 pb-20" data-id="element-6798">
        <div className="container mx-auto px-4 md:px-6" data-id="element-6799">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-6800">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-6801">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-6802">
                <MailIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-6803" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6804">
                Contact Us via Email
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-6805">
                Please send your inquiries to{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-6806">
                  support@yourdomain.com
                </a>
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-6807">
                We typically respond within 24 hours.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6 mb-6" data-id="element-6808">
              <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6809">
                What to Include in Your Email
              </h2>
              <ul className="space-y-2 text-gray-600 dark:text-[#B0C1BD]" data-id="element-6810">
                <li className="flex items-start" data-id="element-6811">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6812">
                    •
                  </span>
                  <span data-id="element-6813">Your account email address</span>
                </li>
                <li className="flex items-start" data-id="element-6814">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6815">
                    •
                  </span>
                  <span data-id="element-6816">Order number (if applicable)</span>
                </li>
                <li className="flex items-start" data-id="element-6817">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6818">
                    •
                  </span>
                  <span data-id="element-6819">Detailed description of your issue or question</span>
                </li>
                <li className="flex items-start" data-id="element-6820">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6821">
                    •
                  </span>
                  <span data-id="element-6822">Screenshots (if relevant)</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-6823">
              <h2 className="text-xl font-semibold mb-2" data-id="element-6824">Support Hours</h2>
              <p className="mb-4 opacity-90" data-id="element-6825">
                Our email support team is available during the following hours:
              </p>
              <div className="space-y-1 mb-4" data-id="element-6826">
                <div className="flex justify-between" data-id="element-6827">
                  <span data-id="element-6828">Monday - Friday:</span>
                  <span data-id="element-6829">9:00 AM - 6:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-6830">
                  <span data-id="element-6831">Saturday:</span>
                  <span data-id="element-6832">10:00 AM - 4:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-6833">
                  <span data-id="element-6834">Sunday:</span>
                  <span data-id="element-6835">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-6836" />
    </div>;
};